import { Uuid } from '../../models/common';
import { GlobalAppCollection } from '../../models/app';
import { AppCollectionScenarios } from '../../models/enums';
import { AppCollectionParameter } from './types';

export enum ApiCacheTag {
  AppData = 'AppData',
  Reviews = 'Reviews',
  Collection = 'Collection',
  AppsInCollection = 'AppsInCollection',
  MyApps = 'MyApps',
  MerchantData = 'MerchantData',
}

type TagId = Uuid | string | number;
export type TagWithId = {
  type: ApiCacheTag,
  id: TagId
}

export const apiTagCreator = (type: ApiCacheTag, id?: TagId): TagWithId | ApiCacheTag => {
  if (!id) return type;
  return {
    type, id,
  };
};

export const getAppCollectionScenarioTagId = ({ scenario, appId }: AppCollectionParameter): string => `${scenario}${(appId ? `|${appId}` : '')}`;

export const getInstallUninstallInvalidateTags = (appId: Uuid, collectionsRelatedToApp: GlobalAppCollection[] = [], type?: 'install' | 'uninstall') => {
  let invalidateTags = [apiTagCreator(ApiCacheTag.AppData, appId), apiTagCreator(ApiCacheTag.Collection, getAppCollectionScenarioTagId({ scenario: AppCollectionScenarios.AppMarket })), apiTagCreator(ApiCacheTag.MyApps)];
  for (let i = 0, len = collectionsRelatedToApp.length; i < len; i++) {
    const collection = collectionsRelatedToApp[i],
      { id } = collection,
      appsInCollectionLength = collection.carouselApps.length;

    if (type === 'install' && appsInCollectionLength === 2) {
      for (let otherApp of collection.carouselApps) {
        if (otherApp.id !== appId) {
          invalidateTags.push(apiTagCreator(ApiCacheTag.Collection, getAppCollectionScenarioTagId({
            scenario: AppCollectionScenarios.AppDetails,
            appId: otherApp.id,
          })));
        }
      }
    } else if (type === 'uninstall' && appsInCollectionLength === 1) {
      invalidateTags.push(apiTagCreator(ApiCacheTag.Collection, getAppCollectionScenarioTagId({
        scenario: AppCollectionScenarios.AppDetails,
        appId: collection.carouselApps[0].id,
      })));
    }

    invalidateTags.push(apiTagCreator(ApiCacheTag.AppsInCollection, id));
  }
  return invalidateTags;
};
